import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Trophy, Lock } from "@phosphor-icons/react";
import { ACHIEV_ICONS } from "@/components/ProfileWidgets";

export default function AchievementsDialog({ open, onOpenChange, achievements }) {
  const unlocked = achievements.filter(a => a.unlocked);
  const locked = achievements.filter(a => !a.unlocked);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0e0e13] border-white/10 text-white max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="achievements-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <Trophy size={22} weight="fill" className="text-[#F59E0B]" /> Todas as Conquistas
            <span className="ml-2 text-sm text-zinc-400 font-mono-accent">{unlocked.length}/{achievements.length}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-4">
          {[...unlocked, ...locked].map(a => {
            const Icon = ACHIEV_ICONS[a.icon] || Trophy;
            return (
              <div
                key={a.id}
                data-testid={`dialog-achievement-${a.id}`}
                className={`p-4 rounded-xl border ${a.unlocked ? "bg-[#E63946]/5 border-[#E63946]/30" : "bg-[#121217] border-white/5 opacity-70"}`}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className={`w-11 h-11 rounded-lg grid place-items-center ${a.unlocked ? "bg-[#E63946] text-white" : "bg-[#1C1C22] text-zinc-600"}`}>
                    {a.unlocked ? <Icon size={22} weight="fill" /> : <Lock size={18} weight="bold" />}
                  </div>
                  <div className="font-mono-accent text-[10px] text-zinc-500">
                    {a.current}/{a.target}
                  </div>
                </div>
                <div className="mt-3 font-display font-bold text-sm">{a.name}</div>
                <div className="text-[11px] text-zinc-500 mt-1 leading-snug">{a.desc}</div>
                {!a.unlocked && a.target > 1 && (
                  <div className="mt-2 h-1 bg-[#1C1C22] rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-[#E63946] to-[#7209B7]" style={{ width: `${a.progress * 100}%` }} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
